import gql from 'graphql-tag'

const AllPossibleTransitions = gql`
  query AllPossibleTransitions ($claimId: String!){
    allPossibleTransitions (claimId: $claimId)
  }
`

export { AllPossibleTransitions }



// WEBPACK FOOTER //
// ./src/queries/AllPossibleTransitions.js